<template>
  <BaseModal :id="'static'" :title="title" :size="'lg'">
    <template v-slot:breadcrumb>
      <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
      <form class="col s12" @submit.prevent="form_submit()">
        <div class="row m-0 formdynamic justify-content-md-between">
          <div class="col-md-6 forecaster__select__item p-0 formdynamic__item">
            <div class="formdynamic__item__field">
              <label
                v-html="`Building: <b style='color:red;'>*</b>`"
                class="modal-label"
              />
              <select
                class="input-field custom-select"
                :style="`font-size:12px; height: 32px;`"
                :required="true"
                v-model="form_data.building_id"
              >
                <option value="" v-html="'Select an option'" />
                <option
                  v-for="(value, i) in array_options.building_id"
                  :key="i"
                  :value="value.id"
                  v-html="value.name"
                />
              </select>
            </div>
          </div>
          <div class="col-md-6 forecaster__select__item p-0 formdynamic__item">
            <div class="formdynamic__item__field">
              <label
                v-html="`Level: <b style='color:red;'>*</b>`"
                class="modal-label"
              />
              <select
                class="input-field custom-select"
                :style="`font-size:12px; height: 32px;`"
                :required="true"
                v-model="form_data.level_id"
              >
                <option value="" v-html="'Select an option'" />
                <option
                  v-for="(value, i) in array_options.level_id"
                  :key="i"
                  :value="value.id"
                  v-html="value.name"
                />
              </select>
            </div>
          </div>
          <div class="col-md-6 forecaster__select__item p-0 formdynamic__item">
            <div class="formdynamic__item__field">
              <label
                v-html="`Area: <b style='color:red;'>*</b>`"
                class="modal-label"
              />
              <select
                class="input-field custom-select"
                :style="`font-size:12px; height: 32px;`"
                :required="true"
                v-model="form_data.area_id"
              >
                <option value="" v-html="'Select an option'" />
                <option
                  v-for="(value, i) in array_options.area_id"
                  :key="i"
                  :value="value.id"
                  v-html="value.name"
                />
              </select>
            </div>
          </div>
          <div class="col-md-6 forecaster__select__item p-0 formdynamic__item">
            <div class="formdynamic__item__field">
              <label
                v-html="
                  `Find rooms with this task: <b style='color:red;'>*</b>`
                "
                class="modal-label"
              />
              <select
                class="input-field custom-select"
                :style="`font-size:12px; height: 32px;`"
                :required="true"
                v-model="task_id"
              >
                <option value="" v-html="'Select an option'" />
                <option
                  v-for="(value, i) in array_options.task_id"
                  :key="i"
                  :value="value.id"
                  v-html="value.name"
                />
              </select>
            </div>
          </div>
        </div>

        <div class="forecaster__buttons d-md-flex">
          <div class="forecaster__buttons__item">
            <button
              class="button--1"
              @click="start_search()"
              type="button"
              v-html="'Go'"
            />
          </div>
        </div>

        <div
          class="tab-pane fade active show"
          id="listation"
          v-if="rooms.length"
        >
          <div class="row">
            <div class="col-lg-12">
              <v-card>
                <v-data-table
                  v-model="table_selection"
                  :headers="table_headers"
                  :items="rooms"
                  :search="search"
                  :single-select="single_select"
                  item-key="id"
                  show-select
                  class="elevation-1"
                />
              </v-card>
            </div>
          </div>
        </div>
        <CentralButtons :type="'create'" />
      </form>
    </template>
  </BaseModal>
</template>

<script>
import FormResources from "./form_resources";
import modalMethods from "./modalMethods";
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import BaseModal from "@/components/BaseModal";
import CentralButtons from "@/components/CentralButtons";

export default {
  name: "FormModal",
  props: [
    "title",
    "rest_api",
    "notyf",
    "axios",
    "breadcrumb",
    "array_options",
    "task_id",
  ],

  components: {
    Breadcrumb,
    BaseModal,
    CentralButtons,
  },

  mixins: [modalMethods],

  data() {
    return {
      form_data: FormResources.search_form_data,
      form_format: FormResources.search_form_format,
      form_backup: { ...FormResources.search_form_data },

      search: "",
      single_select: false,
      rooms: [],
      table_selection: [],
      table_headers: [
        {
          text: "Door number",
          align: "start",
          value: "door_number",
        },
        {
          text: "Description",
          value: "description",
        },
        {
          text: "Abbreviation",
          value: "abbreviation",
        },
        {
          text: "Current task",
          value: "current_task",
        },
      ],
    };
  },
};
</script>